module.exports = __webpack_public_path__ + "img/3.204764b1.png";